/**CORE LIBRARIES IMPORT */
import React from "react";


const ApplicationDetail=()=>{
    return(
        <>
        <div className="footer-margin"></div>
        </>
    )
}

export default ApplicationDetail;